import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import messages from '../translate'

function SiteFilter(props) {
  const {
    activeSite: propActiveSite,
    siteList: immutableSiteList,
    intl: { formatMessage },
  } = props
  const activeSite = propActiveSite || ''
  const siteList = immutableSiteList.toArray()

  const onSiteChange = ({ currentTarget: { dataset } }) => {
    const { activeSite, setSite, siteList } = props
    const currentSite = siteList.get(dataset.index)
    if (currentSite.id !== activeSite) {
      setSite(currentSite.id)
    }
  }

  return (
    <FormControl fullWidth disabled={!siteList.length > 1}>
      <InputLabel htmlFor="active-site-list">
        {formatMessage(messages.site)}
      </InputLabel>
      <Select
        value={activeSite}
        onChange={onSiteChange}
        inputProps={{
          id: 'active-site-list',
        }}>
        {siteList.map(({ id, name }, index) => (
          <MenuItem key={id} value={id} data-index={index}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default connect(state => ({
  siteList: state.getIn(['logbookForm', 'siteList']),
  licensee: state.getIn(['profile', 'profile', 'licensee']),
}))(injectIntl(SiteFilter))
